/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CalendlyDemoLink } from '../models/calendly-demo-link';
import { getCalendlyDemoLink } from '../fn/calendly-demo-link-api/get-calendly-demo-link';
import { GetCalendlyDemoLink$Params } from '../fn/calendly-demo-link-api/get-calendly-demo-link';

@Injectable({ providedIn: 'root' })
export class CalendlyDemoLinkApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCalendlyDemoLink()` */
  static readonly GetCalendlyDemoLinkPath = '/v1/api/ui/calendly-demo/link/{phoneReference}/{contactReference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCalendlyDemoLink()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCalendlyDemoLink$Response(params: GetCalendlyDemoLink$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendlyDemoLink>> {
    return getCalendlyDemoLink(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCalendlyDemoLink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCalendlyDemoLink(params: GetCalendlyDemoLink$Params, context?: HttpContext): Observable<CalendlyDemoLink> {
    return this.getCalendlyDemoLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<CalendlyDemoLink>): CalendlyDemoLink => r.body)
    );
  }

}
